import {
  chakra,
  ComponentSingleStyleConfig,
  useStyleConfig,
} from "@chakra-ui/react";
import React from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";

export type DummyTextareaButtonProps = {
  label?: string;
  onClick: () => void;
} & ComponentStyleProps;

export const CMDummyTextareaButton = ({
  label,
  onClick,

  sx,
  ...rest
}: DummyTextareaButtonProps) => {
  const styles = useStyleConfig("DummyTextareaButtonStyles");

  return (
    <chakra.button {...rest} onClick={onClick} sx={{ ...styles, ...sx }}>
      {label}
    </chakra.button>
  );
};

export const DummyTextareaButtonStyles: ComponentSingleStyleConfig = {
  baseStyle: {
    w: "100%",
    minH: "42px",

    px: "4",
    py: "2",

    textAlign: "left",
    border: "solid 1px",
    borderColor: "gray.300",
    borderRadius: "md",
    fontSize: "sm",
    color: "gray.500",
    cursor: "text",
    backgroundColor: "white",
  },
};
